import { Box } from "@material-ui/core";
import { useContext } from "react";
import CorpoClinicoAttachmentDataComponent from "../../../components/materialui/CorpoClinico/CorpoClinicoAttachmentDataComponent";
import { CorpoClinicoContext } from "../../../../context/CorpoClinicoContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";

export default function CorpoClinicoAttachmentDataStep() {

    const { state, dispatch, updateFile, deleteFile } = useContext(CorpoClinicoContext);

    const onInputAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: { form, value: fieldAttachment, name, subType: "Insert", id: ""},
        });
        updateFile(name, form, fieldAttachment, formField);
    };

    const onDeleteAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        deleteFile(name, form, fieldAttachment, formField);
    };

    return (
        <div>
            <Steps.StepTitle text="Anexos" />

            <Box mt={2}>
                <CorpoClinicoAttachmentDataComponent CorpoClinicoAttachmentForm={state.AttachmentForm} onInputChange={onInputAttachmentChange} onDeleteFile={onDeleteAttachmentChange} />
            </Box>
        </div>
    );
}